<template>
  <div>
    <div class="add_form_modal_wrapper">
      <div class="add_form_modal__containers">
        <div class="add-block-title d-flex justify-content-between align-items-center px-3 py-2">
          <h4 class="my-0">{{ $t("navigations.create form") }}</h4>
          <div class="tooltip-wrapper pointer" @click.prevent="$emit('closeModal')"
            style="float: right; cursor: pointer;">
            <i class="fa fa-times cursor-pointer"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </div>
        </div>
        <div class="row w-100 mx-auto">
          <div class="col-lg-12 mt-3">
            <label for="form-name">{{$t("navigations.form name")}}<sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input type="text" maxlength="1000" class="form-control mb-3" id="form-name" v-model="formName"
              @input="errors.formName = false" placeholder="" aria-label="Form name" aria-describedby="form name">
            <span class="text-danger" v-if="errors.formName">
              {{ errors.formNameMessage }}
            </span>
          </div>
          <div class="col-lg-12">
            <label for="therapeutic-area">
              {{ $t("navigations.therapeutic area") }}
            </label>
            <select class="form-select mb-3" id="therapeutic-area" v-model="formData.therapeuticAreaId">
              <option disabled value="">{{ $t("navigations.select") }}</option>
              <option v-for="area in therapeuticAreas" :key="area.id" :value="area.id">
                {{ area.name }}
              </option>
            </select>
          </div>


          <div class="col-lg-12">
            <label for="form-category">
              {{ $t("navigations.form category") }}
            </label>
            <select class="form-select mb-3" id="form-category" v-model="formData.formCategoryId">
              <option disabled value="">{{ $t("navigations.select") }}</option>
              <option v-for="category in formCategories" :key="category.id" :value="category.id">
                {{ category.formCategory }}
              </option>
            </select>
          </div>


          <div class="col-lg-12 py-3">
            <button type="button" class="btn add_btn d-flex mx-auto py-0" @click.prevent="createForm()">{{
              $t("navigations.submit") }}</button>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>
<script src="./createForm.js"></script>

<style scoped>
.tooltip-wrapper {
  position: relative;
}
.custom-tooltip-popups {
  position: absolute;
  top: 100%; /* or adjust as needed */
  transform: translateX(-80%);
  white-space: nowrap; /* keeps the tooltip text in one line */
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 1000; /* make sure it's above other elements */
}

.add_form_modal_wrapper {
  position: absolute;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  transition: all .3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  padding-top: 100px;
}

.add_form_modal__containers {
  width: min(400px, 90%);
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.add-block-title {
  color: #ffffff;
  background-color: #768DD3;
}

.add_btn {
  color: #ffffff;
  background-color: #768DD3;
}

.add_btn:is(:hover, :focus, :active) {
  background-color: #768DD3;
}

.text-danger {
  font-size: 0.875rem;
}
</style>